import React from 'react'

const DynamicsStyles = ({resourceFetcher}) => {
    return (
        <style>
            {
                `
                @font-face {
                    font-family: 'WorkSans-Medium';
                    src: url('${resourceFetcher.getCompleteResourceUrl("assets/fonts/WorkSans-Medium.ttf")}')  format('truetype');
                    url('${resourceFetcher.getCompleteResourceUrl("assets/fonts/WorkSans-Medium.ttf")}')  format('truetype');
                }
                @font-face {
                    font-family: 'Foco-Black';
                    src: url('${resourceFetcher.getCompleteResourceUrl("assets/fonts/Foco-Black.ttf")}')  format('truetype');
                    url('${resourceFetcher.getCompleteResourceUrl("assets/fonts/Foco-Black.ttf")}')  format('truetype');
                }
                
                `
            }
        </style>
    )
}

export default DynamicsStyles;
